module.exports = __webpack_public_path__ + "img/developer-dark.708a2b5d.svg";